module.exports = __webpack_public_path__ + "img/deluxe-filter-welcome-background-mazda.e7200f76.png";